<template>
    <BModal
            v-model="isOpen"
            size="lg"
            no-enforce-focus
            centered
            hide-footer
            title="Edit invoice line"
    >
        <div v-if="invoiceLine">
            <div class="row">
                <p class="col-12 text-muted mb-3"><strong>General Info</strong></p>
            </div>
            <div class="row">
                <AppSelect
                        :value="invoiceLine.product"
                        :multiple="false"
                        :options="productSuggestions"
                        track-by="id"
                        label-field="name"
                        :errors="errors"
                        label="Referenced product"
                        placeholder=""
                        class="col-md-4"
                        @open="suggestProducts(null)"
                        @search-change="suggestProducts($event)"
                        @input="
            updateInvoiceLineProps({
              product: $event ? $event : null,
              product_id: $event ? $event.id : null
            })
          "
                />
                <AppWysiwyg
                        :value="invoiceLine.description"
                        label="Description"
                        @input="updateDescription($event)"
                        class="col-12"
                        rows="4"
                        field="description"
                />
            </div>
            <div class="row">
                <AppInput
                        :value="invoiceLine.quantity"
                        @input="updateInvoiceLineProps({ quantity: $event })"
                        class="col-md-4"
                        label="Quantity"
                        field="quantity"
                />
                <AppInput
                        :value="invoiceLine.price"
                        @input="updateInvoiceLineProps({ price: $event.replace(',', '.') })"
                        class="col-md-4"
                        label="Price per unit (€)"
                        field="price"
                />
                <AppSelect
                        :value="invoiceLine.unit_type"
                        :multiple="false"
                        :options="unitTypes"
                        track-by="code"
                        label-field="name"
                        label="Unit type"
                        class="col-md-4"
                        placeholder=""
                        @input="
            updateInvoiceLineProps({
              unit_type_code: $event ? $event.code : null,
              unit_type: $event
            })
          "
                />
            </div>
            <div class="row mt-3">
                <div class="col-12 text-right">
                    <button class="btn btn-danger mr-2" @click="destroy">Delete</button>
                    <button class="btn btn-primary" @click="save">Save</button>
                </div>
            </div>
        </div>
    </BModal>
</template>

<script>
import { mapGetters } from 'vuex';
import { BModal } from 'bootstrap-vue';
import debounce from 'lodash.debounce';
import Errors from '../../utils/errors';
import AppWysiwyg from '../form/AppWysiwyg';
import AppInput from '../form/AppInput';
import AppSelect from '../form/AppSelect';

export default {
  data() {
    return {
      errors: new Errors(),
      productSuggestions: [],
      description: null,
    };
  },
  components: {
    AppSelect,
    AppInput,
    AppWysiwyg,
    BModal,
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.invoices.isLineModalOpen;
      },
      set(val) {
        this.$store.commit('invoices/isLineModalOpen', val);
      },
    },
    ...mapGetters({
      invoiceLine: 'invoices/invoiceLine',
      unitTypes: 'unitTypes/unitTypes',
    }),
  },
  methods: {
    updateDescription(text) {
      this.description = text;
    },
    suggestProducts: debounce(function suggest(query) {
      const params = {
        query,
      };

      return this.$store.dispatch('products/suggestProducts', params)
        .then((suggestions) => {
          this.productSuggestions = suggestions;
        });
    }, 300),
    save() {
      if (this.description !== null) {
        this.updateInvoiceLineProps({ description: this.description });
      }
      this.$store.commit('invoices/isLineModalOpen', false);
      this.$store.dispatch('invoices/updateInvoice');
    },
    destroy() {
      //     this.$bvModal.msgBoxConfirm('Delete order line?', { okTitle: 'Delete' })
      //        .then((value) => {
      //         if (value) {
      this.$store.dispatch('invoices/deleteInvoiceLine')
        .then(() => {
          this.$store.dispatch('invoices/updateInvoice');
        });
      //          }
      //        });
      this.$store.commit('invoices/isLineModalOpen', false);
    },
    updateInvoiceLineProps(props) {
      this.$store.dispatch('invoices/updateInvoiceLineProps', props);
    },
  },
};
</script>
